window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('body.controller--inquiries')) return false

  //
})
